import React from 'react';
import { getAnalistaDisplayNome } from '../../FuncoesGerais/tipoAnalista';

function ChamadoResponsavelCard({
    atendenteNome,
    opcoesAtendentes,
    novoResponsavelId,
    onNovoResponsavelChange,
    onAtribuir,
    salvandoAtribuicao,
    carregandoOpcoes,
    readOnly,
}) {
    const nomeAtual = (atendenteNome || '').toString().trim();
    const opcoes = Array.isArray(opcoesAtendentes) ? opcoesAtendentes : [];
    const selecionado = (novoResponsavelId || '').toString().trim();
    const itemSelecionado = opcoes.find((o) => String(o.id) === String(selecionado));
    const nomeSelecionado = itemSelecionado ? (itemSelecionado.nome || '').toString().trim() : '';

    return (
        <div className="chamado-sidebar-card chamado-responsavel-card">
            <h4 className="chamado-sidebar-card-titulo">Responsável</h4>
            {nomeAtual ? (
                <p className="chamado-responsavel-atual">{nomeAtual}</p>
            ) : (
                <p className="chamado-responsavel-vazio">Sem responsável definido.</p>
            )}
            {!readOnly && (
            <div className="chamado-responsavel-atribuir">
                <select
                    className="chamado-responsavel-select"
                    value={selecionado}
                    onChange={(e) => onNovoResponsavelChange(e.target.value)}
                    aria-label="Atribuir chamado para"
                >
                    <option value="">Atribuir para...</option>
                    {opcoes.map((u) => (
                        <option key={u.id} value={u.id}>{getAnalistaDisplayNome(u.nome || `Usuário ${u.id}`, u)}</option>
                    ))}
                </select>
                {carregandoOpcoes && <span className="chamado-responsavel-opcoes-loading">Carregando...</span>}
                <button
                    type="button"
                    className="chamado-collab-btn-add"
                    onClick={() => onAtribuir(selecionado, nomeSelecionado)}
                    disabled={salvandoAtribuicao || !selecionado}
                >
                    {salvandoAtribuicao ? 'Atribuindo...' : 'Atribuir'}
                </button>
            </div>
            )}
        </div>
    );
}

export default ChamadoResponsavelCard;
